import psiExports from "@configs/awsexports/psi.json";
import simwerxExports from "@configs/awsexports/simwerx.json";
import therapyedExports from "@configs/awsexports/therapyed.json";
import thiemeneetpg from "@configs/awsexports/thiemeneetpg.json";
import toeflBetaExports from "@configs/awsexports/toefl-beta.json";
import toeflExports from "@configs/awsexports/toefl.json";
import { buildType } from "@helpers/expo-extras";
import { isDev } from "@memorang/constants";
import { Apps } from "types/apps";

export const getAwsExportsJson = () => {
	switch (buildType) {
		case Apps.TherapyEd:
			return therapyedExports;
		case Apps.Psi:
			return psiExports;
		case Apps.thiemeneetpg:
			return thiemeneetpg;
		case Apps.Simwerx:
			return simwerxExports;
		case Apps.Toefl:
			return isDev ? toeflBetaExports : toeflExports;
		default:
			return therapyedExports;
	}
};
